/*
 * @Author: zhaozhuo
 * @Date: 2021-10-11 16:49:24
 * @LastEditors: zhangquanming 419654548@qq.com
 * @LastEditTime: 2023-12-23 15:18:25
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\main.js
 */
import 'lib-flexible'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './request/index'// 接口api
import { filterRules } from './rule'// 校验规则
import { global } from './utils/global.js' // 全局方法
import * as filters from './filters'// 过滤器
import { buttonAuthorith } from '@/assets/js/authority'// 按钮权限指令字典
import './directive'// 全局指令
import './register'// 注册组件
import '@/assets/iconfont/iconfont.css'
import locals from '@/local'
Vue.prototype.$locals = locals
Vue.prototype.$api = api
Vue.prototype.$filterRules = filterRules
Vue.prototype.$utils = global
Vue.prototype.$bus = new Vue()
Vue.prototype.$buttonAuthorith = buttonAuthorith
Vue.config.productionTip = false
// 全局过滤器
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key])
})
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
